<template>
  <div :class="device.isMobile ? 'py-2' : 'px-4 pb-2'">
    <v-row align="center" class="mb-4">
      <v-col cols="12" lg="auto">
        <report-field-select-food-company></report-field-select-food-company>
      </v-col>
      <v-col cols="8" lg="auto">
        <dropdown
          :label="$t('order_status')"
          :items="statusItems"
          v-model="orderStatus"
          hide-details
        ></dropdown>
      </v-col>
      <v-col cols="4" lg="auto">
        <shift-picker v-model="selectedShifts" multiple />
      </v-col>
    </v-row>

    <v-data-table
      :headers="getMobileHeaders(headers)"
      :items="customSearch(users, headers, filters.search)"
      class="ordera-box-shadow striped-table"
      dense
      hide-default-footer
      disable-pagination
      mobile-breakpoint="0"
      :loading="loading"
      :loading-text="$t('loading')"
    >
      <template v-slot:no-data>
        <v-container class="text-center py-12">
          <v-icon size="64" color="grey lighten-1" class="mb-4"> mdi-account-off </v-icon>
          <div class="text-h6 grey--text text--darken-1 mb-2">
            {{ $t("no_group_meals_data") }}
          </div>
          <div class="text-body-2 grey--text">
            {{ $t("select_date_and_filters") }}
          </div>
        </v-container>
      </template>
      <!-- Custom cell rendering for each column -->
      <template v-slot:[`item.num`]="{ item, index }">
        {{ item.id === $t("total") ? "" : index + 1 }}
      </template>
      <template v-slot:item.id="{ item }">
        <span v-if="item.id === $t('total')">{{ $t("totalU") }}</span>
        <span v-else style="color: #1976d2">
          {{ item.id }}
        </span>
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:item.lastname="{ item }">
        {{ item.lastname }}
      </template>
      <template v-slot:item.order_date="{ item }">
        <span
          :title="$t('order_datetime')"
          v-if="filters.dates.from === filters.dates.to"
        >
          {{ item.id !== $t("total") && item.order_count > 0 ? item.order_date : "" }}
        </span>
      </template>
      <template v-slot:item.shift_one="{ item }">
        {{ item.shift_one || "" }}
      </template>
      <template v-slot:item.shift_two="{ item }">
        {{ item.shift_two || "" }}
      </template>
      <template v-slot:item.shift_three="{ item }">
        {{ item.shift_three || "" }}
      </template>
      <template v-slot:item.shift_four="{ item }">
        {{ item.shift_four || "" }}
      </template>
      <template v-slot:item.order_count="{ item }">
        <span>
          {{ item.order_count }}
        </span>
      </template>
      <template v-slot:item.order_payed="{ item }">
        {{ item.order_payed }}
      </template>
      <template v-slot:item.action="{ item }">
        <circle-button
          v-if="String(item.id).toLowerCase() !== $t('total').toLowerCase()"
          @click="openDialogReportUser(item)"
          icon="mdi-format-list-bulleted"
          color="primary"
          :tooltip="$t('tooltip_order_details')"
        ></circle-button>
      </template>
      <template v-slot:body.append v-if="orderStatus < 2">
        <tr class="text-weight-bold">
          <td v-if="!device.isMobile"></td>
          <td>{{ $t("totalU") }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td v-if="filters.dates.from === filters.dates.to"></td>
          <td v-if="selectedShifts.includes(1)">{{ totals.shift_one || 0 }}</td>
          <td v-if="selectedShifts.includes(2)">{{ totals.shift_two || 0 }}</td>
          <td v-if="selectedShifts.includes(3)">{{ totals.shift_three || 0 }}</td>
          <td v-if="selectedShifts.includes(4)">{{ totals.shift_four || 0 }}</td>
          <td>{{ totals.order_count || 0 }}</td>
          <td>{{ totals.order_payed || 0 }}</td>
          <td>{{ (totals.order_count || 0) - (totals.order_payed || 0) }}</td>
          <td></td>
        </tr>
      </template>
    </v-data-table>

    <report-employee-order-history-dialog
      v-model="dialogReport"
      :company="selectedCompany"
      :employee="userReportItem"
    ></report-employee-order-history-dialog>
  </div>
</template>

<script>
import moment from "moment";
import hasPrinting from "@/mixins/hasPrinting";
import ReportEmployeeOrderHistoryDialog from "@/components/report/employee/dialogs/ReportEmployeeOrderHistoryDialog.vue";
import ReportFieldSelectFoodCompany from "@/components/report/fields/ReportFieldSelectFoodCompany.vue";
import hasReportPrinting from "@/mixins/report/hasReportPrinting";
import hasExcel from "@/mixins/hasExcel";
import hasReloadWatch from "@/mixins/report/hasReloadWatch";
import hasOrderCalculations from "@/mixins/report/hasOrderCalculations";
import hasMobileHeaders from "@/mixins/report/hasMobileHeaders";
import reportService from "@/services/report";

export default {
  mixins: [
    hasPrinting,
    hasReportPrinting,
    hasExcel,
    hasReloadWatch,
    hasOrderCalculations,
    hasMobileHeaders,
  ],
  components: {
    ReportFieldSelectFoodCompany,
    ReportEmployeeOrderHistoryDialog,
  },
  data() {
    return {
      search: "",
      orderUsers: [],
      userReportItem: null,
      loading: false,
      ordersByMonth: [],
      ukupnoPorudzbina: [],
      dialogReport: false,
      totals: {},
      selectedShifts: [1, 2, 3, 4],
    };
  },
  computed: {
    users() {
      let order_count_total = 0;
      let order_payed_total = 0;
      let order_meals_total = 0;
      let shift_one_total = 0;
      let shift_two_total = 0;
      let shift_three_total = 0;
      let shift_four_total = 0;
      // Process users using mixin method
      const processedUsers = this.processUsersOrderData(this.orderUsers);

      processedUsers.forEach((user) => {
        order_count_total += user.order_count;
        order_payed_total += user.order_payed;
        order_meals_total += user.meals;
        shift_one_total += user.shift === 1 ? user.order_count : 0;
        shift_two_total += user.shift === 2 ? user.order_count : 0;
        shift_three_total += user.shift === 3 ? user.order_count : 0;
        shift_four_total += user.shift === 4 ? user.order_count : 0;
      });

      // Filter users by status using mixin method
      const filteredUsers = this.filterUsersByStatus(processedUsers, this.orderStatus);

      const users = filteredUsers.map((user, index) => {
        return {
          ...user,
          num: index + 1,
          name: this.translate(user.name),
          lastname: this.translate(user.lastname),
          order_date: user.order_date,
          shift_one: user.shift === 1 ? user.order_count : 0,
          shift_two: user.shift === 2 ? user.order_count : 0,
          shift_three: user.shift === 3 ? user.order_count : 0,
          shift_four: user.shift === 4 ? user.order_count : 0,
          difference: user.order_count - user.order_payed,
        };
      });

      // Calculate totals from filtered users
      const totals_order_count = users.reduce((sum, user) => sum + user.order_count, 0);
      const totals_order_payed = users.reduce((sum, user) => sum + user.order_payed, 0);
      const totals_shift_one = this.selectedShifts.includes(1)
        ? users.reduce((sum, user) => sum + user.shift_one, 0)
        : 0;
      const totals_shift_two = this.selectedShifts.includes(2)
        ? users.reduce((sum, user) => sum + user.shift_two, 0)
        : 0;
      const totals_shift_three = this.selectedShifts.includes(3)
        ? users.reduce((sum, user) => sum + user.shift_three, 0)
        : 0;
      const totals_shift_four = this.selectedShifts.includes(4)
        ? users.reduce((sum, user) => sum + user.shift_four, 0)
        : 0;

      // Store totals for body.append slot
      this.totals = {
        shift_one: totals_shift_one,
        shift_two: totals_shift_two,
        shift_three: totals_shift_three,
        shift_four: totals_shift_four,
        order_count: totals_order_count,
        order_payed: totals_order_payed,
        meals: order_meals_total,
      };

      return users;
    },
    usersWithTotals() {
      const usersData = [...this.users];
      usersData.push({
        id: this.$t("totalU"),
        num: "",
        external_code: "",
        name: " ",
        lastname: " ",
        date: " ",
        shift_one: this.totals.shift_one || 0,
        shift_two: this.totals.shift_two || 0,
        shift_three: this.totals.shift_three || 0,
        shift_four: this.totals.shift_four || 0,
        order_count: this.totals.order_count || 0,
        order_payed: this.totals.order_payed || 0,
        difference: (this.totals.order_count || 0) - (this.totals.order_payed || 0),
      });
      return usersData;
    },
    printHeaders() {
      return this.headers.filter((header) => {
        return !["action", "num", "id"].includes(header.value);
      });
    },
    selectedCompany() {
      return this.$store.state.report.selectedCompany;
    },
    headers() {
      const baseHeaders = [
        { text: this.$t("r_b"), value: "num" },
        { text: "ID", value: "id" },
        { text: this.$t("external_code"), value: "external_code" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("last_name"), value: "lastname" },
      ];

      if (this.filters.dates.from === this.filters.dates.to) {
        baseHeaders.push({
          text: this.$t("order_time"),
          value: "order_date",
          sort: (a, b) => {
            if (!a || !b) return 0;
            const dateA = moment(a, "DD.MM.YYYY HH:mm").toDate();
            const dateB = moment(b, "DD.MM.YYYY HH:mm").toDate();
            return dateA - dateB;
          },
        });
      }

      const shiftHeaders = [];
      if (this.selectedShifts.includes(1)) {
        shiftHeaders.push({ text: this.$t("shift_one"), value: "shift_one" });
      }
      if (this.selectedShifts.includes(2)) {
        shiftHeaders.push({ text: this.$t("shift_two"), value: "shift_two" });
      }
      if (this.selectedShifts.includes(3)) {
        shiftHeaders.push({ text: this.$t("shift_three"), value: "shift_three" });
      }
      if (this.selectedShifts.includes(4)) {
        shiftHeaders.push({ text: this.$t("shift_four"), value: "shift_four" });
      }

      const endHeaders = [
        { text: this.$t("ordered"), value: "order_count" },
        { text: this.$t("taken"), value: "order_payed" },
        { text: this.$t("difference"), value: "difference" },
        { text: this.$t("report"), value: "action" },
      ];

      return [...baseHeaders, ...shiftHeaders, ...endHeaders];
    },
    filters() {
      return this.$store.state.report.filters;
    },
  },
  methods: {
    findUsers() {
      if (!this.selectedCompany) {
        this.users = [];
        return;
      }
      this.loading = true;
      const params = {
        date: this.filters.dates.from,
        date2: this.filters.dates.to,
      };
      reportService
        .getCompanyFoodKorisnici(this.selectedCompany.id, params)
        .then((res) => {
          this.orderUsers = res.data?.users || [];
        })
        .catch((error) => {
          console.error("Error loading users:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDialogReportUser(item) {
      this.userReportItem = item;
      this.dialogReport = true;
    },
  },
  watch: {
    "filters.dates": {
      handler() {
        this.findUsers();
      },
      deep: true,
    },
    selectedCompany: {
      handler() {
        this.findUsers();
      },
      immediate: true,
    },
    isPrinting() {
      if (this.isPrinting) {
        const title = `<h3 style="text-align: center">
            ${
              this.toLatin(this.selectedCompany?.company || this.selectedCompany?.name) +
              " " +
              this.subtitle
            }
          </h3>`;
        this.printDocument({
          tables: [
            {
              headers: this.printHeaders,
              items: this.usersWithTotals,
              showCaption: true,
              title,
            },
          ],
          title: [this.$t("report"), this.$t("users")].join(": "),
          hideDatetime: true,
        });
      }
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        this.downloadExcel({
          fileName: [this.$t("report"), this.$t("users")].join(" ") + ".xlsx",
          sheets: [
            {
              name: this.$t("users"),
              headers: this.headers,
              items: this.usersWithTotals,
              title: [this.$t("report"), this.$t("users")].join(" "),
              subtitle: this.subtitle,
              beforeTableHtml: `<h4 style="text-align: center">${this.selectedCompany?.company}</h4>`,
            },
          ],
        });
      }
    },
  },
};
</script>
